<template>
    <div v-if="localStatistics && properties">        
        <!-- TableView -->
        <table>
            <thead>
                <th>Spielerin</th>
                <th v-for="q in properties" v-bind:key="q.id" :class="tableSortOrder == q.id ? 'is-sortable is-selected' : 'is-sortable'" @click="changeOrder(q.id)">{{ q.title }}</th>
                <th>Spiele</th>
            </thead>
            <tr v-for="p,idx in localStatistics.slice(0, limit)" v-bind:key="p.fmpPlayerId">
                <td class="tableUser">
                    <div class="tableUser__position">
                        {{ idx+1 }}
                    </div>
                    <div @click="openProfile(p)" class="tableUser__avatar">
                        <div class="tableUser__avatar__badge tableUser__avatar__badge--flag">
                            <img :src="playerFlag(p)" alt="">
                        </div>
                        <img :src="'https://hbf-helper.deinsportplatz.de/images/person/' + p.fmpPlayerId + '/square'" alt="">
                    </div>
                    <div @click="openProfile(p)"  class="tableUser__text">
                        <div class="tableUser__text__sub">
                        {{ p.firstName }}
                        </div>
                        <div class="tableUser__text__main">
                        {{ p.lastName }}
                        </div>
                    </div>
                </td>
                <td v-for="q in properties" v-bind:key="q.id">{{ p[q.key] }}</td>
                <td>{{ p.totalMatches }}</td>
            </tr>

            <tr v-if="limit < localStatistics.length">
                <td colspan="6">
                    <button v-if="limit < 30" class="load-more" @click="limit = limit + 10">
                        <img src="@/assets/ic_12_arrow.svg">
                        10 weitere anzeigen
                    </button>
                    <button v-else class="load-more" @click="limit = localStatistics.length">
                        <img src="@/assets/ic_12_arrow.svg">
                        Alle anzeigen
                    </button>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>

import {slugify} from '@/hbf-helper';

export default {
    name: 'PlayerStatisticsTable',
    props: {
        tableSize: {
            type: Number,
            default() { return null; }
        },
        statistics: {
            type: Array,
            default() { return [] }
        },
        properties: {
            type: Array,
            default() { return [] } 
        },
        competitionId: {
            type: Number,
            default() { return -1; }
        }
    },
    data() {
        return {
            localStatistics: [...this.statistics],
            tableSortOrder: 1,
            limit: 10,
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.properties && this.properties.length > 0) {
                this.tableSortOrder = this.properties[0].id;
                this.changeOrder(this.tableSortOrder);
            }
        },
        playerFlag(player) {
            if (player && player.nationality) {
                try {
                    return require("@/assets/flags/flag_" + player.nationality + ".svg");
                }
                catch(error) {
                    console.error(error);
                }
            }
            return require("@/assets/1x1.png");
        },
        changeOrder(newOrder) {
            var item = this.properties.find(p => p.id == newOrder);
            if (!item) { return; }
            this.tableSortOrder = newOrder;
            this.localStatistics.sort( (s1, s2) => s2[item.key] - s1[item.key] || s2[item.key2] - s1[item.key2] || s2[item.key3] - s1[item.key3] );
        },
        openProfile(s) {
            if (!s) { return; }
            var profileUrl = "/profile/" + s.fmpPlayerId + "--" + slugify(s.firstName + "-" + s.lastName) + "/" + this.competitionId + "/" + s.fmpTeamId;
            this.$router.push(profileUrl);
        },
    },
    computed: {
        baseUrl() {
            return this.$store.getters.getBaseUrl;
        }
    }
}
</script>

<style scoped>
    .button_row {
        margin-top: 10px;
        text-align: center;
    }
</style>
